import React from "react";
import { t } from "ttag";

import { Themed } from "../../../styles/themes";
import { Clickable } from "../../Clickables";
import { Svg } from "../../Svg";
import { ProgressBar } from "../ProgressBar/ProgressBar";
import { AppState } from "../engine";

import styles from "./ModalHeader.module.scss";

/**
 * Top strip rendered on every modal surface — walk screens,
 * confirmations, the hub. Three zones: SKS logo (left), progress bar
 * (center; renders nothing on populated walks and the hub via
 * `getProgressBar`), and the My Suite trigger + close × (right). The ×
 * dispatches `CLOSE_BUILDER` via the parent's `onClose` callback;
 * universal close that returns to landing whether the shopper is in a
 * walk or on the hub.
 */
export type ModalHeaderProps = {
    state: AppState;
    onOpenMiniCart: () => void;
    onClose: () => void;
};

export const ModalHeader = ({
    state,
    onOpenMiniCart,
    onClose,
}: ModalHeaderProps) => {
    const suiteCount = state.suite.contributions.length;

    return (
        <Themed theme="offWhite" tag="header">
            <div className={styles.inner}>
                <Svg name="sks-logo" className={styles.logo} />
                <ProgressBar state={state} />
                <div className={styles.actions}>
                    <Clickable
                        onClick={onOpenMiniCart}
                        className={styles.miniCartTrigger}
                    >
                        {t`My Suite (${suiteCount})`}
                    </Clickable>
                    <Clickable onClick={onClose} className={styles.close}>
                        <Svg name="x" visuallyHiddenText={t`Close`} />
                    </Clickable>
                </div>
            </div>
        </Themed>
    );
};
